<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1>Kategorie</h1>
           <v-layout class="layout--controls">
               <v-btn
                       color="primary"
                       type="submit"
                       class="button--top control"
                       @click="addCategory()"
               >Vytvořit kategorii</v-btn>
               <v-text-field
                       class="input--search control"
                       placeholder="Vyhledat"
                       outlined
                       v-model="search"
               ></v-text-field>
           </v-layout>

           <v-layout class="table-items">
               <div class="category-tree elevation-1 full-width">
                   <div class="category-tree__row category-tree__row--header">
                       <div class="category-tree__cell category-tree__cell--handle"></div>
                       <div class="category-tree__cell">ID</div>
                       <div class="category-tree__cell category-tree__cell--grow">Název</div>
                       <div class="category-tree__cell category-tree__cell--grow">Slug</div>
                       <div class="category-tree__cell">Publikováno</div>
                       <div class="category-tree__cell">SEO</div>
                       <div class="category-tree__cell"></div>
                   </div>

                   <draggable
                           v-model="topLevel"
                           tag="div"
                           group="categories"
                           handle=".category-tree__drag-handle"
                           chosen-class="category-tree__node--dragging"
                           @end="persistTree()"
                   >
                       <category-tree-node
                               v-for="parent in topLevel"
                               :key="parent.id"
                               v-show="matchesBranch(parent)"
                               :category="parent"
                               :depth="0"
                               @end="persistTree()"
                       />
                   </draggable>
               </div>
               <div v-if="topLevel.length === 0" class="text-no-results">
                   <p>Žádná kategorie nebyla nalezena</p>
               </div>
           </v-layout>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import draggable from 'vuedraggable';
    import CategoryTreeNode from '@/components/CategoryTreeNode.vue';

    export default {
        name: 'Categories',
        components: {
            draggable,
            CategoryTreeNode
        },

        data() {
            return {
                loaded: false,
                search: '',
                topLevel: []
            }
        },

        created() {
            this.fetchData();
        },
        computed: {
            ...mapState(['profile']),
        },
        mounted(){
        },
        methods: {
            addCategory(){
              this.$router.push({name: 'CategoriesDetail', params: {id: 'add'}})
            },
            matchesSearch(category){
                if(!this.search){
                    return true;
                }
                const search = this.search.toLowerCase();
                return category.name.toLowerCase().includes(search) || category.slug.toLowerCase().includes(search);
            },
            matchesBranch(parent){
                if(this.matchesSearch(parent)){
                    return true;
                }
                return parent.children.some((child) => this.matchesSearch(child));
            },
            fetchData(){
                this.$axios.get('/admin/categories').then((response) => {
                    this.topLevel = this.buildTree(response.data.categories);
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            buildTree(categories){
                return categories
                    .filter((c) => !c.parent_id)
                    .map((parent) => ({
                        ...parent,
                        children: categories.filter((c) => c.parent_id === parent.id)
                    }));
            },
            persistTree(){
                const categories = [];
                const flatten = (nodes, parentId) => {
                    nodes.forEach((node, index) => {
                        categories.push({id: node.id, parent_id: parentId, sort_order: index + 1});
                        if(node.children && node.children.length){
                            flatten(node.children, node.id);
                        }
                    });
                };
                flatten(this.topLevel, null);

                this.$axios.put('/admin/categories/reorder', {categories}).then(() => {
                    this.fetchData();
                }).catch((e) => {
                    this.fetchData();
                });
            }
        },
        watch: {

        }
    }
</script>


<style lang="scss">
    .category-tree {
        background: #fff;
        width: 100%;

        &__row {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eee;

            &--header {
                font-weight: bold;
            }

            &--child {
                background: #fafafa;
            }
        }

        &__cell {
            padding: 8px 12px;
            flex: 0 0 100px;

            &--grow {
                flex: 1 1 auto;
            }

            &--handle {
                flex: 0 0 40px;
                cursor: move;
            }
        }

        &__children {
            min-height: 16px;
            margin-left: 24px;
        }

        &__node--dragging {
            background: #e3f2fd;
        }
    }
</style>
